import markInk from '@/assets/mads-mark-ink.svg'
import markWhite from '@/assets/mads-mark-white.svg'

interface LogoProps {
  /** `lockup` sets the wordmark beside the mark, `stacked` under it. */
  layout?: 'lockup' | 'stacked' | 'mark'
  theme?: 'ink' | 'white'
  size?: number
}

/**
 * The MADS mark paired with a Montserrat "Tech Inventory" wordmark — the
 * lockup that appears on every surface (spec §2, Identity & palette).
 */
export function Logo({ layout = 'lockup', theme = 'ink', size = 40 }: LogoProps) {
  const classes = ['logo-lockup']
  if (layout === 'stacked') classes.push('is-stacked')
  if (theme === 'white') classes.push('is-white')

  return (
    <span className={classes.join(' ')} style={{ gap: size * 0.2 }}>
      <img
        className="logo-mark"
        src={theme === 'white' ? markWhite : markInk}
        alt="MADS Theatre"
        style={{ height: size * 1.365 }}
      />
      {layout !== 'mark' && (
        <span className="logo-wordmark" style={{ fontSize: size * 0.42 }}>
          Tech
          <br />
          Inventory
        </span>
      )}
    </span>
  )
}
